import { AxiosInstance } from 'axios';

export class Component {
  protected requester: AxiosInstance;

  constructor(requester: AxiosInstance) {
    this.requester = requester;
  }
}
